module.exports = __webpack_public_path__ + "static/media/bitcare.73c9367d.png";